import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import './ApplicantPage.scss';
import { VehicleBox } from './ViewBlocks/VehicleBox';
import { OrderServiceBox } from './ViewBlocks/OrderServiceBox';
import { CarrierBox } from './ViewBlocks/CarrierBox';
import { ApplicantBox } from './ViewBlocks/ApplicantBox';
import { getApplicantData } from '../reducer';
import InDevelopment from './ViewBlocks/InDevelopment';
import { ApplicationBox } from './ViewBlocks/ApplicationBox';
import { APPLICANT_MENU } from '../../../configs';
import { getLegalEntityName } from '../../../utils/formatters';

export function ApplicantDetails(props) {
  const { onClose } = props;
  const [selected, setSelected] = useState(APPLICANT_MENU.APPLICANT_1);
  const {
    currentApplicant,
  } = useSelector(getApplicantData);

  const {
    formatMessage,
  } = intlShape;

  function HeaderInfo() {
    const headerInfoBlock = document.getElementById('header-info-block');
    return headerInfoBlock ? (ReactDOM.createPortal(
      <div className="sub-page-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev" onClick={onClose}>Просмотр карточки заявителя</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">{getLegalEntityName(currentApplicant)}</span>
        </div>
      </div>,
      headerInfoBlock,
    )) : null;
  }

  return ReactDOM.createPortal(
    <div className="applicant-card">
      <HeaderInfo />
      <div className="applicant-container">
        <div className="applicant-menu">
          <div className="applicant-menu-user-fio">
            {getLegalEntityName(currentApplicant)}
          </div>
          <div className="applicant-menu-list">
            {Object.values(APPLICANT_MENU).map((item, index) => (
              <div key={index} className={classNames('applicant-menu-list-item', { isActive: selected === item })} onClick={() => setSelected(item)}>
                <div className="applicant-menu-list-item-title">
                  <Icons customIcon icon={item} />
                  <div>{formatMessage({ id: `applicant.card.menu.${item}` })}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        { selected === APPLICANT_MENU.SERVICE ? <OrderServiceBox onClose={onClose} currentApplicant={currentApplicant} /> : null }
        { selected === APPLICANT_MENU.CARRIER ? <CarrierBox onClose={onClose} currentApplicant={currentApplicant} /> : null }
        { selected === APPLICANT_MENU.VEHICLE ? <VehicleBox onClose={onClose} currentApplicant={currentApplicant} /> : null }
        { selected === APPLICANT_MENU.APPLICATION ? <ApplicationBox onClose={onClose} currentApplicant={currentApplicant} /> : null }
        { selected === APPLICANT_MENU.APPLICANT_1 ? <ApplicantBox onClose={onClose} id={currentApplicant?.id} /> : null }
        { selected === APPLICANT_MENU.APPLICANT_2 ? <InDevelopment onClose={onClose} /> : null }
        { selected === APPLICANT_MENU.APPLICANT_3 ? <InDevelopment onClose={onClose} /> : null }
      </div>
    </div>,
    document.getElementById('app-content-children'),
  );
}
